import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

import { CLIENTS_ROUTES } from "@routes/clients"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"

import ClientTableView from "./views/ClientTableView/ClientTableView"

export default function ClientList() {
    const [createRoute] = useSlugExtractor([CLIENTS_ROUTES.CREATE])

    return (
        <AppFrame.Root collaborationRoomName="client-list">
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageTitle label={objectMap.client.labelPlural} icon={objectMap.client.iconActive} />
                    </NavTopBar.NavTopBarHeaderStart>
                    <NavTopBar.NavTopBarHeaderEnd>
                        <NavTopBar.PagePresence />
                        <AccessCheck
                            permissions={{
                                clients_list_permission: PERMISSION_LEVEL.RESTRICTED,
                            }}
                        >
                            <AccessCheck
                                permissions={{
                                    clients_view_permission: PERMISSION_LEVEL.FULL,
                                }}
                            >
                                <NavTopBar.SearchButton scope="Clients" />
                            </AccessCheck>
                        </AccessCheck>
                        <AccessCheck
                            permissions={{
                                clients_create_permission: PERMISSION_LEVEL.RESTRICTED,
                            }}
                        >
                            <NavTopBar.CTAButton destination={createRoute} />
                        </AccessCheck>
                    </NavTopBar.NavTopBarHeaderEnd>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <ClientTableView />
        </AppFrame.Root>
    )
}
